export class Palabra {

    palabra: String;
    idioma: String;

}